import React, { Fragment, FunctionComponent } from "react";
import FooterProps from "./FooterProps.interface";

import Footer1 from "./blocks/Footer1/Footer1";
import Footer2 from "./blocks/Footer2/Footer2";
import Footer3 from "./blocks/Footer3/Footer3";

const FOOTER_TYPES: { [key: string]: any } = {
    "blockFooter1": Footer1,
    "blockFooter2": Footer2,
    "blockFooter3": Footer3
};

const Footer: FunctionComponent<FooterProps> = (props) => {
    const DynamicFooter = FOOTER_TYPES[props.contentType];

    return (
        <Fragment>
            {DynamicFooter && props.settings ? (
                <DynamicFooter {...props.settings} />
            ) : null}
        </Fragment>
    );
};

export default Footer;